import { render, staticRenderFns } from "./OrgFeeProjection.vue?vue&type=template&id=fd0b665c&scoped=true&"
import script from "./OrgFeeProjection.vue?vue&type=script&lang=js&"
export * from "./OrgFeeProjection.vue?vue&type=script&lang=js&"
import style0 from "./OrgFeeProjection.vue?vue&type=style&index=0&id=fd0b665c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd0b665c",
  null
  
)

export default component.exports